
import analyse from './assets/analyse.png'
import verified from './assets/verified.png'

const Sobre = () => {
    return ( 
        <div className="sobre" id='sobre'>
            <div className="sobre-texts">
                <h2>Especializados em <span>saúde mental</span></h2>
                <span className='sobre-description'>Com uma equipe de médicos e suporte terapêutico multidisciplinar dedicados, entendemos os desafios enfrentados por quem vive o universo das apostas e acreditamos que todos merecem suporte para superar suas dificuldades.</span>
                <div className="sobre-checks">
                    <div className="sobre-individual-check">
                        <img src={verified} alt="" />
                        <span>Atendimento rápido</span>
                    </div>
                    <div className="sobre-individual-check">
                        <img src={verified} alt="" />
                        <span>Soluções responsáveis</span>
                    </div>
                </div>
            </div>
            <img src={analyse} alt="" />
        </div>
     );
}
 
export default Sobre;